import { VISIT_TYPES, visitTypeLabels } from "~/services";

type VisitTypeValue = (typeof VISIT_TYPES)[keyof typeof VISIT_TYPES];

export const getVisitTypeTitle = (visitType: VisitTypeValue): string =>
  visitTypeLabels[visitType] ?? "Visit";
